import { render } from "./Clients.vue?vue&type=template&id=00b77ae4&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=00b77ae4&scoped=true&lang=css"

import exportComponent from "/home/garyblake/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b77ae4"]])

export default __exports__